var render, staticRenderFns
import script from "./ReportPageParent.vue?vue&type=script&lang=js&"
export * from "./ReportPageParent.vue?vue&type=script&lang=js&"
import style0 from "./ReportPageParent.vue?vue&type=style&index=0&id=a4e5f226&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e5f226",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4e5f226')) {
      api.createRecord('a4e5f226', component.options)
    } else {
      api.reload('a4e5f226', component.options)
    }
    
  }
}
component.options.__file = "src/components/stats/widgets/ReportPageParent.vue"
export default component.exports